module.exports = __webpack_public_path__ + "img/luma.abeaa734.png";